/*
  Mouse drag for Dawn product sliders (ul.slider[data-mouse-drag]).
  Only the mouse is handled: touch and trackpad keep their native scrolling.
  A click without movement still follows the link; a drag never opens a product.
*/
(function () {
  if (window.__sliderMouseDragReady) return;
  window.__sliderMouseDragReady = true;

  var THRESHOLD = 6;

  // Snap position of every slide in scrollLeft units (respects scroll-padding / scroll-margin, LTR and RTL).
  function snapTarget(slider, bias) {
    var slides = slider.querySelectorAll(':scope > li');
    if (!slides.length) return slider.scrollLeft;
    var r = slider.getBoundingClientRect();
    var cs = getComputedStyle(slider);
    var rtl = cs.direction === 'rtl';
    var sl = slider.scrollLeft;
    var max = slider.scrollWidth - slider.clientWidth;
    var wanted = sl + bias;
    var best = null;
    for (var i = 0; i < slides.length; i++) {
      var lr = slides[i].getBoundingClientRect();
      var ls = getComputedStyle(slides[i]);
      var t = rtl
        ? sl + (lr.right + (parseFloat(ls.scrollMarginRight) || 0)) - (r.right - (parseFloat(cs.scrollPaddingRight) || 0))
        : sl + (lr.left - (parseFloat(ls.scrollMarginLeft) || 0)) - (r.left + (parseFloat(cs.scrollPaddingLeft) || 0));
      t = rtl ? Math.min(0, Math.max(-max, t)) : Math.max(0, Math.min(max, t));
      if (best === null || Math.abs(t - wanted) < Math.abs(best - wanted)) best = t;
    }
    return best;
  }

  function setup(slider) {
    if (slider.dataset.mouseDragBound) return;
    slider.dataset.mouseDragBound = '1';

    var down = false;
    var dragging = false;
    var lastDx = 0;
    var startX = 0;
    var startScroll = 0;
    var pointerId = null;
    var blockClick = false;

    slider.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    slider.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest('button, input, select, textarea, label')) return;
      if (slider.scrollWidth <= slider.clientWidth + 1) return;
      down = true;
      dragging = false;
      startX = e.clientX;
      startScroll = slider.scrollLeft;
      pointerId = e.pointerId;
    });

    slider.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;
      lastDx = dx;
      if (!dragging) {
        if (Math.abs(dx) < THRESHOLD) return;
        dragging = true;
        slider.classList.add('is-mouse-dragging');
        try { slider.setPointerCapture(pointerId); } catch (err) {}
        var sel = window.getSelection && window.getSelection();
        if (sel && sel.removeAllRanges) sel.removeAllRanges();
      }
      e.preventDefault();
      slider.scrollLeft = startScroll - dx;
    });

    function end(e) {
      if (!down || (e && e.pointerId !== pointerId)) return;
      down = false;
      if (!dragging) return;
      dragging = false;
      blockClick = true;
      setTimeout(function () { blockClick = false; }, 60);
      try { slider.releasePointerCapture(pointerId); } catch (err) {}
      // Lean towards the drag direction so a short drag still moves to the next product.
      var first = slider.querySelector(':scope > li');
      var step = first ? first.getBoundingClientRect().width * 0.35 : 0;
      var bias = lastDx < 0 ? step : lastDx > 0 ? -step : 0;
      var target = snapTarget(slider, bias);
      slider.classList.remove('is-mouse-dragging');
      slider.scrollTo({ left: target, behavior: 'smooth' });
    }

    slider.addEventListener('pointerup', end);
    slider.addEventListener('pointercancel', end);
    slider.addEventListener('lostpointercapture', function (e) {
      if (dragging) end(e);
    });

    slider.addEventListener(
      'click',
      function (e) {
        if (!blockClick) return;
        e.preventDefault();
        e.stopPropagation();
        blockClick = false;
      },
      true
    );
  }

  function init(root) {
    (root || document).querySelectorAll('ul.slider[data-mouse-drag]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
